import PropTypes from 'prop-types'

import {ChevronRightIcon} from './icons'
import {LIFE_STORY_CHAPTERS} from './lifeStoryContent'
import {answeredStories, storyCountLabel} from './lifeStoryTools'

import './chapterSwitchScreen.scss'

/** "Where to next?" — step one of the chapter picker; a chapter opens its question list. */
const ChapterSwitchScreen = ({stories, openChapter, back}) => {
  const chapterMeta = chapter => {
    const answeredCount = answeredStories(stories.filter(story => story['chapter-key'] === chapter.key)).length

    if (answeredCount === 0) return 'Begin'

    return `${storyCountLabel(answeredCount)}`
  }

  return (
    <div className='chapter-switch-screen'>
      <div className='ls-top'>
        <button className='ls-exit' onClick={back}>&larr; Back</button>
      </div>
      <div className='ls-switch'>
        <h1>Where to next?</h1>
        <p className='ls-switch-sub'>
          Open a chapter, and see where its questions lead.
        </p>
        <div className='ls-chapter-list'>
          {
            LIFE_STORY_CHAPTERS.map(chapter => {
              const meta = chapterMeta(chapter)

              return (
                <button
                  className={`ls-chapter-row${meta === 'Begin' ? '' : ' has-stories'}`}
                  key={chapter.key}
                  onClick={() => openChapter(chapter.key)}>
                  <span className='ls-chapter-name'>{chapter.name}</span>
                  <span className='ls-chapter-meta'>{meta}</span>
                  <span className='ls-chapter-chevron'>
                    <ChevronRightIcon />
                  </span>
                </button>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}

ChapterSwitchScreen.propTypes = {
  back: PropTypes.func,
  openChapter: PropTypes.func,
  stories: PropTypes.array
}

export default ChapterSwitchScreen
